/* eslint-disable max-len */
import { Row, Rows, Section, Sections } from '~/components/molecules/footer/types'

const serviceAndHelpSections: Sections = [
    {
        headline: 'Service & Hilfe',
        items: [
            {
                title: 'Häufige Fragen',
                href: '/haeufige-fragen',
            },
            {
                title: 'Kontakt',
                href: '/kontakt',
            },
            {
                title: 'Versand',
                href: '/versand',
            },
            {
                title: 'Bezahlung',
                href: '/haeufige-fragen',
            },
            {
                title: 'Retourenportal',
                href: '/returnPortal?icid=footer_retoure_nn_nn_nn_nn_nn_nn_nn',
                target: '_blank',
            },
            {
                title: 'Widerrufsformular',
                href: '/media/pdf/dc/01/58/230627_Widerufsformular-v03.pdf',
                target: '_blank',
            },
        ],
    },
]

const aboutWeinfreundeSections: Sections = [
    {
        headline: 'Rund um Weinfreunde',
        items: [
            {
                title: 'Freunde werben',
                href: '/freunde-werben?icid=footer_freunde-werben_nn_nn_nn_nn_nn_nn_nn',
            },
            {
                title: 'Weinfreunde Magazin',
                href: '/magazin/?icid=footer_magazin_nn_nn_nn_nn_nn_nn_nn',
            },
            {
                title: 'Bei Anruf Wein Podcast',
                href: '/podcast?icid=footer_podcast_nn_nn_nn_nn_nn_nn_nn',
            },
            {
                title: 'Gewinnspiele',
                href: '/gewinnspiele?icid=footer_gewinnspiel_nn_nn_nn_nn_nn_nn_nn',
                target: '_blank',
            },
        ],
    },
]

const onSiteSection: Section = {
    headline: 'Vor Ort',
    items: [
        {
            title: 'Weinfreunde bei REWE',
            href: '/magazin/marktsuche/?icid=lp_modulweine_marktsuche_cta_nn_nn_nn_nn_nn',
            target: '_blank',
        },
    ],
}

const companySection: Section = {
    headline: 'Unternehmen',
    items: [
        {
            title: 'Über uns',
            href: '/ueber-uns?icid=footer_ueber-uns_nn_nn_nn_nn_nn_nn_nn',
        },
        {
            title: 'Jobs',
            href: 'https://rewe-digital.dvinci-hr.com/de/p/weinfreundejobs/jobs?icid=footer_jobs_nn_nn_nn_nn_nn_nn_nn',
            target: '_blank',
        },
        {
            title: 'Presse',
            href: '/magazin/presse/?icid=footer_presse_nn_nn_nn_nn_nn_nn_nn',
            target: '_blank',
        },

        {
            title: 'Geschäftskunden',
            href: '/geschaeftskunden',
        },
        {
            title: 'Partnerprogramm',
            href: '/partnerprogramm?icid=footer_partnerprogramm_nn_nn_nn_nn_nn_nn_nn',
        },
    ],
}

const categoriesAndBrandsRow: Row = {
    isMobileGrouped: true,
    columns: [
        {
            sections: [
                {
                    headline: 'Kategorien & Marken',
                    items: [
                        {
                            title: 'Italienische Rotweine',
                            href: '/rotweine/rotweine-aus-italien/',
                        },
                        {
                            title: 'Spanische Rotweine',
                            href: '/rotweine/rotweine-aus-spanien/',
                        },
                        {
                            title: 'Französische Rotweine',
                            href: '/rotweine/rotweine-aus-frankreich/',
                        },
                        {
                            title: 'Portugiesische Rotweine',
                            href: '/rotweine/rotweine-aus-portugal/',
                        },
                    ],
                },
            ],
        },
        {
            sections: [
                {
                    isPlaceHolderHeadline: true,
                    items: [
                        {
                            title: 'Italienische Weißweine',
                            href: '/weissweine/weissweine-aus-italien/',
                        },
                        {
                            title: 'Französische Weißweine',
                            href: '/weissweine/weissweine-aus-frankreich/',
                        },
                        {
                            title: 'Deutsche Weißweine',
                            href: '/weissweine/weissweine-aus-deutschland/',
                        },
                        {
                            title: 'Spanische Weißweine',
                            href: '/weissweine/weissweine-aus-spanien/',
                        },
                    ],
                },
            ],
        },
        {
            sections: [
                {
                    isPlaceHolderHeadline: true,
                    items: [
                        {
                            title: 'Alkoholfreie Weine',
                            href: '/alkoholfreie-weine',
                        },
                        {
                            title: 'Freundschaftswein',
                            href: '/freundschaftswein',
                        },
                        {
                            title: 'Cà dei Frati',
                            href: '/ca-dei-frati',
                        },
                        {
                            title: 'Rotweine aus Bordeaux',
                            href: '/region/bordeaux/',
                        },
                    ],
                },
            ],
        },
        {
            sections: [
                {
                    isPlaceHolderHeadline: true,
                    items: [
                        {
                            title: 'Champagner',
                            href: '/champagner/',
                        },
                        {
                            title: 'Primitivo di Manduria',
                            href: '/primitivo-di-manduria',
                        },
                        {
                            title: 'Amarone',
                            href: '/amarone/',
                        },
                        {
                            title: 'Lugana',
                            href: '/lugana/',
                        },
                    ],
                },
            ],
        },
    ],
}

export const sitemapRows: Rows = [
    {
        columns: [
            {
                sections: serviceAndHelpSections,
            },
            {
                sections: aboutWeinfreundeSections,
            },
            {
                sections: [onSiteSection],
            },
            {
                sections: [companySection],
            },
        ],
    },
    categoriesAndBrandsRow,
]

